export class EnvironmentConfig {
  surveyEndPoint: string;
  turnstileKey: string;
}
